import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import reducer, {Response} from './store'

export default reducer

// @ts-expect-error to be fixed
export type BuildVersionMatchState = EntityState<Response>
